import { USER_DETAIL_TABS } from '@steado/admin-contract/user-detail';
import { z } from 'zod';

import { aiSpendWindowSchema } from '@/screens/ai-spend/ai-spend-search';

/**
 * The open tab, the paged scan cursor and the open transcript live in the URL.
 *
 * Same reasoning as the list's filters: "look at this user's coach session" is
 * a link an operator can paste into a ticket, and the back button should walk
 * back through tabs rather than off the screen.
 *
 * `.catch` on each field: a stale link naming a tab that was renamed lands on
 * Profile rather than on an error page.
 */
export const userDetailSearchSchema = z.object({
  tab: z.enum(USER_DETAIL_TABS).default('profile').catch('profile'),
  cursor: z.string().optional().catch(undefined),
  session: z.string().uuid().optional().catch(undefined),
  /**
   * The AI tab's window. Carried from Spend by user, so a row clicked in the
   * 7-day ranking opens on the same 7 days rather than on a different number.
   */
  aiDays: aiSpendWindowSchema.optional().catch(undefined),
});

export type UserDetailSearch = z.infer<typeof userDetailSearchSchema>;
